export function parseJobcard(texto) {
  if (!texto) {
    return { titulo: "", descripcion: "", oficios: [], suministros: [], unidadDeMedida: null };
  }

  const oficiosMatch = texto.match(/Oficios:\s*(.+?)(?=\s*Suministros:|\s*Unidad de medida:|$)/s);
  const suministrosMatch = texto.match(/Suministros:\s*(.+?)(?=\s*Unidad de medida:|$)/s);
  const unidadMatch = texto.match(/Unidad de medida:\s*(.+?)$/);

  const oficios = oficiosMatch
    ? oficiosMatch[1]
        .split(/[;.]/)
        .map((s) => s.trim())
        .filter(Boolean)
    : [];

  const suministros = suministrosMatch
    ? suministrosMatch[1]
        .split(";")
        .map((s) => s.trim().replace(/\.$/, ""))
        .filter(Boolean)
    : [];

  const unidadDeMedida = unidadMatch ? unidadMatch[1].trim() : null;

  let cabecera = texto;
  if (oficiosMatch) cabecera = cabecera.split(/Oficios:/)[0];
  if (suministrosMatch && !oficiosMatch) cabecera = cabecera.split(/Suministros:/)[0];
  if (unidadMatch && !oficiosMatch && !suministrosMatch) {
    cabecera = cabecera.split(/Unidad de medida:/)[0];
  }
  cabecera = cabecera.trim();

  const partes = cabecera.split(".");
  const titulo = (partes.shift() ?? "").trim();
  const descripcion = partes.join(".").trim();

  return { titulo, descripcion, oficios, suministros, unidadDeMedida };
}
